(function(window, angular, undefined) {
    var app = angular.module('formApp');
    app.directive("equalHeight", ['$timeout', function($timeout) {
        return {
            link: function ($scope, $element, $attrs) {

                var elm = document.getElementsByClassName("equal-heights");
                var maxHeight = 0;

                if (window.innerWidth >= "781"){
                    $timeout(function(){
                        // Get the max height from all divs
                        for (var i = 0; i < elm.length; i++) {
                            var elmHeight = elm[i].offsetHeight;
                            if (elm[i].offsetHeight > maxHeight) {
                                maxHeight = elmHeight;
                            }
                            // set max height to the all div
                            elm[i].style.height = (maxHeight) + "px";
                        } 
                    });
                }
            }
        };
    }]);
})(window, window.angular);